<template>
<div>
	
	<Navbar></Navbar>
	
	<Loader :show="loading"></Loader>

	<div class="container-fluid">
		
		<div class="side-bar" :class="{'opened':preview && !editMode }">
			<div class="page-header">
				<div class="title">
					<h1>Ver slot</h1>
				</div>
				<div class="btn btn-close icon icon-sm icon-close" @click="preview=null"></div>
			</div>
			
			<div class="mt-4" v-if="preview">
				<div class="d-flex justify-content-between mb-2">
					<h5>{{preview.code}}</h5>
				</div>

				<h6 v-if="preview.multiple">Espacio múltiple</h6>
				<h6 v-else>Espacio simple</h6>
				
					<!-- <div class="alert alert-success m-0" v-if="preview.status=='FREE'">LIBRE</div> -->
				<div v-if="preview.cars.length>0" class="mt-4">
					<label class="m-0">Vehículo<span v-if="preview.cars.length>1">s</span></label>
					<div v-for="car in preview.cars" :key="car.id" class="car-detail">
						<h5>{{car.brand.title}} {{car.model}}</h5>
						<label class="mt-1 mb-0">Chasis</label>
						<h4 >{{car.chassis_number}}</h4>
					</div>
				</div>
			</div>
			
		</div>
		
		<div class="side-bar" :class="{'opened':editForm }">
			<div class="page-header">
				<div class="title">
					<h1>Editar slot</h1>
				</div>
				<div class="btn btn-close icon icon-sm icon-close" @click="editForm=null"></div>
			</div>
			
			<div class="mt-4" v-if="editForm">
				<div class="d-flex justify-content-between mb-2">
					<h5>{{editForm.code}}</h5>
				</div>

				
				<b-form-group label="Código">
					<b-form-input
						v-model="editForm.code"
						placeholder="Código"
					></b-form-input>
				</b-form-group>
				
				<b-form-group label="Multiple" class="mt-2">
					<select v-model="editForm.multiple" class="form-control">
						<option :value="false">No</option>
						<option :value="true">Si</option>
					</select>
				</b-form-group>

				<div class="btn btn-success btn-block mt-2" @click="updateSlot(editForm)">Guardar</div>
				
			</div>

			
		</div>

		<div class="top-bar">
			<div class="title">
				Mapa
			</div>
			<div class="actions ">

				<!-- <div class="form-group mr-4">
					<label class="col-form-label p-0">Modo edición</label>
					<div class="">
						<toggle-button 
							:value="true"
							v-model="editMode"
							:labels="{checked: 'Si', unchecked: 'No'}"
						/>
					</div>
				</div> -->

				<b-form-group class="mr-4">
					<select v-model="depositId" class="form-control" @change="load">
						<option value="1">Fiscal</option>
						<option value="2">Nacional</option>
					</select>
				</b-form-group>
				

			</div>
		</div>

		<div class="main-content">
			<!-- panZoom -->
			<div v-if="!loading">

				<div class="parking-map" ref="map" >
					<div class="back" @click="editableSlot = null, preview = null" @contextmenu.prevent="$refs.menu.open"></div>
					
					<div v-for="(slot, index) in slots" :key="slot.id" 
						@click.ctrl.left.exact="editableSlot = slot.id, preview = null" 
						@click.left.exact="viewParkingSlot(slot)" 
						@contextmenu.prevent="$refs.slotMenu.open($event, {slot, index})"
						>
						<vue-draggable-resizable 
							:grid="[20,20]" 
							:resizable="editableSlot == slot.id" 
							:draggable="editableSlot == slot.id" 
							:x="slot.position.left" 
							:y="slot.position.top" 
							:w="slot.position.w" 
							:h="slot.position.h" 
							class="slot"
							:class="{
								'occupied':slot.status=='OCCUPIED',
								'free':slot.status=='FREE',
							}"
							:ref="slot.id"
							@dragstop="dragstop(slot)"
							@resizestop="dragstop(slot)"
							>
							<div class="innerElement">
								<span>{{slot.codeparsed[0]}} {{slot.editable}}</span>
								<span>{{slot.codeparsed[1]}}</span>
								<span v-if="slot.multiple && slot.cars.length>0">( {{slot.cars.length}} )</span>

							</div>
						</vue-draggable-resizable>
					</div>
				
				</div>
			</div>
		</div>

	</div>

	<vue-context ref="slotMenu">
		<template slot-scope="child" v-if="child.data">
			<li>
				<a href="#" @click.prevent="showEditForm(child.data)"><i class="fa fa-pencil"></i> Editar</a>
			</li>
			<li>
				<a href="#" @click.prevent="deleteSlot(child.data)"><i class="fa fa-trash"></i> Eliminar</a>
			</li>
		</template>
    </vue-context>
	
	<vue-context ref="menu">
		<template slot-scope="child">
			<li>
				<a href="#" @click.prevent="createSlot()"><i class="fa fa-pencil"></i> Crear slot</a>
			</li>
		</template>
    </vue-context>

	
</div>
</template>
	
<script>
import gql from 'graphql-tag'
import Navbar from '@/components/Navbar'
import Loader from '@/components/Loader'
import mixins from '@/mixins/mixins'

import { VueContext } from 'vue-context';

export default {
	name: 'Map',
	mixins:[mixins],
	components:{
		Navbar,
		Loader,
		VueContext
	},
	data () {
		return {
			parking_slots: [],
			grid: [],
			loading: true,
			slotsWidth: 20,
			slotsHeight: 80,
			preview: null,
			depositId: 2,
			editMode: false,
			editableSlot: null,
			editForm: null
		}
	},
	computed:{
		slots(){
			return this.parking_slots.map( (slot) => {
				slot.codeparsed = slot.code.match(/[a-zA-Z]+|[0-9]+/g)
				return slot
			})
		}
	},
	beforeMount(){
		this.load()
	},
	methods:{
		dragstop(slot)  {
			let element =this.$refs[slot.id][0]
			slot.position.top = element.top
			slot.position.left = element.left
			slot.position.w = element.width
			slot.position.h = element.height
			this.updateSlot(slot)
		},
		load(){
			this.parking_slots = []
			this.loading=true
			this.$apollo.query({
				query: gql`query ($depositId: ID){
					parking_slots (depositId: $depositId){
						id
						code
						deposit{
							id
							title
						}
						multiple
						status
						position{
							top
							left
							w
							h
						}
						cars{
							id
							chassis_number
							model
							brand{
								title
							}
						}
					}
				}`,
				variables: {
					depositId: this.depositId
				},
			})
			.then((data) => {
				this.parking_slots = data.data.parking_slots;
				this.loading = false
			})
			.catch(() => {
				// this.$router.push('/')
			});
		},
		createSlot () {
			let dataInput = {
				deposit_id:  this.depositId
			}

			this.$apollo.mutate({
				mutation: gql`mutation ( $data:ParkingSlotInput! ){
					ParkingSlotCreate( data: $data) {
						id
						code
						deposit{
							id
							title
						}
						multiple
						status
						position{
							top
							left
							w
							h
						}
						cars{
							id
							chassis_number
							model
							brand{
								title
							}
						}
					}
				}`,
				variables: {
					data: dataInput
				}
			})
			.then((data) => {
				this.$toast.success('Slot creado correctamente')
				this.parking_slots.push(data.data.ParkingSlotCreate)
			})
			.catch( (error) => {
				this.errors = this.parseGQLErrors(error)
			})
		},
		updateSlot (slot) {
			let dataInput = {
				position: slot.position,
				code: slot.code,
				multiple: slot.multiple,
			}

			this.$apollo.mutate({
				mutation: gql`mutation ( $id: ID!, $data:ParkingSlotInput! ){
					ParkingSlotUpdate( id: $id, data: $data) {
						id
					}
				}`,
				variables: {
					id: slot.id,
					data: dataInput
				}
			})
			.then(() => {
				this.editForm=null
				this.$toast.success('Cambios guardados')
			})
			.catch( (error) => {
				this.errors = this.parseGQLErrors(error)
			})
		},
		deleteSlot (data) {
			
			this.$apollo.mutate({
				mutation: gql`mutation ( $id: ID! ){
					ParkingSlotDelete( id: $id ) {
						id
					}
				}`,
				variables: {
					id: data.slot.id
				}
			})
			.then(() => {
				this.$toast.success('Slot eliminado correctamente')
				this.parking_slots.splice(data.index,1)
				
			})
			.catch( (error) => {
				this.errors = this.parseGQLErrors(error)
			})
		},
		showEditForm(data){
			this.preview = null	
			this.editForm = data.slot	
		},
		viewParkingSlot(slot){
			if(!this.editableSlot && !this.editForm){
				this.editForm = null
				this.preview = slot	
			}
		}

	},
	
}


</script>

<style scoped lang="scss">
.car-detail{
	position: relative;
    padding: .5rem;
    margin-bottom: .5rem;
    border: 1px solid transparent;
    border-radius: .25rem;
	background-color: #f3f3f3;
    border-color: #e0e0e0;

	label{

	}
	h4{
		font-size: 1rem;
	}
	h5{
		font-size: .9rem;
	}
}

.side-bar{
	width:200px;
	height: calc(100% - 64px);
	position:fixed;
	top:64px;
	right:-200px;
	padding: 18px;
	background-color:#fff;
	z-index: 10;
	transition: all 0.3s ease-in-out;

	&.opened{
		right:0px;
	}
}
.top-bar{
	width: calc(100% - 200px);
	height: 58px;
    padding: 0px 8px;
	right: 0px;
	position:absolute;
	top: 64px;
	border: 1px solid #f3f3f3;
	background-color: #fff;
	display: flex;
	justify-content: space-between;
	align-items: center;

	.title{
		font-size: 1.3125rem;
		font-weight: 500;
	}

	.actions{
		margin-left: 18px;
		flex-grow: 1;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
}
.main-content{
	width: calc(100% - 200px);
	height: calc(100% - 130px);
	position: absolute;
	top: 120px;
	bottom: 0px;
	right: 0px;
	overflow: auto;
	padding: 24px;
	background-color:#eaeaea;
}

.parking-map{
	width:1300px;
	height: 3700px;
	background-color:#f3f3f3;
	position:relative;
	
	.back{
		position: absolute;
		top: 0px;
		left: 0px;
		width: 100%;
		height: 100%;		
	}
	// .row{
	// 	width: 100%;
	// 	flex-wrap: nowrap;
	// 	margin: 0px 2px;
	// }
	.slot{
		display: flex;
		border:solid 1px #fff;
		color: #fff;
		background-color: #c3c3c3;
		text-align: center;
		font-weight: 600;
		flex-grow: 0;     /* do not grow   - initial value: 0 */
		flex-shrink: 0;   /* do not shrink - initial value: 1 */
		justify-content: center;
		align-items: center;
		line-height: 10px;
		font-size: 10px;
		cursor: pointer;
		opacity:0.75;
		position:absolute;
		
		&:hover{
			background-color:#e2dfdf;
		}

		&.occupied{
			background-color:#ff6565;
			color: #fff;
			&:hover{
				opacity:1
			}
		}

		&.free{
			background-color:#66e064;
			color: #fff;
			&:hover{
				
				opacity:1
			}
		}

		.innerElement span{
			margin: 2px;
			display: inline-block;
		}

	}
}

.vue-pan-zoom-item{
	overflow:hidden;
}

</style>
